import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { BitbucketIssueService } from "../../models/integrations/bitbucket-issue.service";

@Component({
  selector: "ab-bitbucket-integration",
  templateUrl: "./bitbucket.component.html",
})
export class BitbucketIntegrationComponent implements OnInit {
  @Input() public notice: any;

  public loading: boolean;
  public issue: any;
  public creatingIssue: boolean;
  public error: any;
  public removingIssue: boolean;

  constructor(private bitbucketIssueSerrvice: BitbucketIssueService) {}

  public ngOnInit() {
    this.loading = true;

    return this.bitbucketIssueSerrvice
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((issue: any) => {
        this.issue = issue;
      });
  }

  public createIssue() {
    this.issue = { notice: this.notice };

    this.creatingIssue = true;
    return this.bitbucketIssueSerrvice
      .create(this.issue)
      .pipe(
        finalize(() => {
          delete this.creatingIssue;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeIssue() {
    this.issue = { notice: this.notice };

    this.removingIssue = true;
    return this.bitbucketIssueSerrvice
      .destroy(this.issue)
      .pipe(
        finalize(() => {
          delete this.removingIssue;
        }),
      )
      .subscribe(() => {
        delete this.issue;
      });
  }
}
